module.exports = __webpack_public_path__ + "static/img/icon_nodota.d4a74108.png";